"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatAmount = void 0;
var formatAmount = exports.formatAmount = function formatAmount(_ref) {
  var cents = _ref.cents,
    locale = _ref.locale,
    _ref$showCents = _ref.showCents,
    showCents = _ref$showCents === void 0 ? false : _ref$showCents;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: showCents ? 2 : 0,
    maximumFractionDigits: showCents ? 2 : 0
  }).format(cents / 100);
};